<template>
  <div id="wrapper">
    <TextHeader
      :headerTitle="$t('events.title')"
      header-bg="radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #080806)"
    />
    <div id="content" class="w-container" v-if="data">
      <SectionHeader :text="title" />
      <div :key="item.id" v-for="item in this.data" class="item-wrapper">
        <div
          class="image"
          :style="{ backgroundImage: 'url(' + item.thumbnail + ')' }"
        ></div>
        <div class="details">
          <h3>{{ item.title }}</h3>
          <div class="separator"></div>
          <div class="description" v-html="item.description"></div>
          <div class="date-wrapper">
            <div class="date">{{ item.date }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeader from "./SectionHeader";
import TextHeader from "./TextHeader";

export default {
  name: "Events",
  components: { SectionHeader, TextHeader },
  data() {
    return {
      data: null,
      title: ""
    };
  },
  watch: {
    $route(to) {
      this.loadData(to.params.type);
    }
  },
  methods: {
    loadData(type) {
      if (type === "news") {
        this.title = this.$t("events.typeNews");
      } else {
        this.title = this.$t("events.typeArchive");
      }
      this.$http.get("events/").then(response => (this.data = response.data));
    }
  },
  mounted() {
    this.loadData(this.$route.params.type);
  }
};
</script>

<style scoped>
#wrapper {
  background-color: #f0f0f0;
}

#content {
  padding: 100px 0;
}

.item-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 76px;
}

.item-wrapper:after {
  content: "";
  clear: both;
}

.item-wrapper:hover {
  background-color: white;
}

.image {
  width: 45%;
  -webkit-box-flex: 0;
  -webkit-flex: 0 auto;
  -ms-flex: 0 auto;
  flex: 0 auto;
  background: no-repeat 50% 0;
  background-size: contain;
}

.details {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-top: 41px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-bottom: 2px solid #000;
}

.details h3 {
  padding-left: 55px;
  color: #000;
  font-size: 2.5em;
  line-height: 1.1em;
  font-weight: 500;
}

.separator {
  position: relative;
  left: -107px;
  bottom: 0px;
  width: 120px;
  height: 6px;
  margin-bottom: 32px;
  margin-left: 60px;
  padding-right: 0px;
  padding-left: 0px;
  background-color: #fff;
  color: #6f6f6f;
}

.description {
  margin-bottom: 39px;
  padding-right: 105px;
  padding-left: 60px;
  font-family: "Fira Sans", sans-serif;
  color: #807d7d;
  font-weight: 300;
  line-height: 1.5em;
  /*height: calc(1.5em);*/
  overflow: hidden;
}

.date-wrapper {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.date {
  position: relative;
  width: 232px;
  padding: 22px 0px;
  border-top: 2px solid #000;
  border-right: 2px solid #000;
  border-left: 2px solid #000;
  background-color: transparent;
  color: #354e61;
  font-size: 1.3em;
  font-weight: 400;
  text-align: center;
}

@media (max-width: 476px) {
  .item-wrapper {
    flex-direction: column;
  }

  .image {
    min-height: 150px;
    width: 100%;
  }
}
</style>
